import React, { useEffect, useState } from "react";
import axios from "axios";
import { Flame } from "lucide-react";
import { Card } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DriverHeatmap() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get(`${API}/driver/heatmap`);
        setData(r.data);
      } catch { /* silent */ }
    };
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, []);

  if (!data || data.total_rides === 0) return null;
  const points = data.points || [];
  const maxCount = Math.max(1, ...points.map(p => p.count));

  return (
    <Card className="p-5" data-testid="driver-heatmap">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-xl bg-red-600 text-white flex items-center justify-center">
          <Flame className="w-5 h-5" />
        </div>
        <div>
          <div className="font-bold text-lg leading-tight">Demanda perto de você</div>
          <div className="text-[11px] text-muted-foreground">{data.total_rides} solicitações nas últimas 24h · top {points.length} zonas</div>
        </div>
      </div>
      <div className="space-y-1 max-h-56 overflow-y-auto">
        {points.slice(0, 10).map((p, i) => {
          const pct = (p.count / maxCount) * 100;
          return (
            <div key={i} className="flex items-center gap-2 text-xs" data-testid={`heatmap-point-${i}`}>
              <div className="w-8 text-muted-foreground font-mono">#{i + 1}</div>
              <div className="flex-1 h-5 rounded bg-muted overflow-hidden relative">
                <div
                  className="h-full rounded"
                  style={{
                    width: `${pct}%`,
                    background: `linear-gradient(90deg, #22c55e, #f59e0b ${pct > 60 ? "60%" : "80%"}, #ef4444)`,
                  }}
                />
                <div className="absolute inset-0 flex items-center px-2 text-[10px] font-semibold text-foreground">
                  {p.lat.toFixed(2)}, {p.lng.toFixed(2)} · {p.count}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
